@if (this.columns.length > 0) {
  <app-table
    [(columnSelection)]="columnSelection"
    [(focusDate)]="focusDate"
    [(selection)]="rowSelection"
    (focusDateChange)="focusDateChange()"
    [actionColumnWidth]="400"
    [columns]="columns"
    [columnSelectable]="true"
    [editable]="true"
    [firstColumnFrozen]="true"
    [focusDateClearable]="false"
    [hasFocusDate]="true"
    [loading]="loading"
    [selectable]="true">
    <ng-template
      (onClick)="activateAllSelected()"
      appToolbarButton
      icon="fal fa-check"
      labelKey="ACTIONS.ACTIVATE"></ng-template>
    <ng-template
      (onClick)="deactivateAllSelected()"
      appToolbarButton
      icon="fal fa-minus"
      labelKey="ACTIONS.DEACTIVATE"></ng-template>
    <ng-template
      (onClick)="addMissingOrganisations()"
      appToolbarButton
      icon="fal fa-plus"
      labelKey="ACTIONS.ADD_MISSING_ORGANISATIONS"></ng-template>
    <ng-template (onClick)="resetWorkdays()" appToolbarButton labelKey="WORKDAYS.RECALCULATE"></ng-template>
    <ng-template
      (onClick)="showDialog($event.row)"
      appActionButton
      displayIf="organisationId"
      icon="fal fa-search"
      labelKey="GLOBAL.DETAILS"></ng-template>
  </app-table>
}
